import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {useTranslation} from 'react-i18next'
import {useState} from 'react'

const LecMenu = () => {
  const {t} = useTranslation()
  const [showMore, setShowMore] = useState(false)

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/lec/my-profile',
      icon: 'fas fa-user',
      bg: '#eef2ff',
      color: '#6366f1',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/lec/my-courses',
      icon: 'fas fa-book-open',
      bg: '#ecfdf5',
      color: '#10b981',
    },
    {
      title: t('MENU.PUBLICATIONS'),
      to: '/lec/publications-list',
      icon: 'fas fa-book',
      bg: '#fffbeb',
      color: '#f59e0b',
    },
    {
      title: t('MEETING.MEETINGS'),
      to: '/lec/meetings',
      icon: 'fas fa-handshake',
      bg: '#fef2f2',
      color: '#ef4444',
    },
    {
      title: t('MENU.REGULATIONS'),
      to: '/lec/regulations',
      icon: 'fas fa-gavel',
      bg: '#f5f3ff',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.FEEDBACK'),
      to: '/lec/feedback',
      icon: 'fas fa-comments',
      bg: '#f0fdfa',
      color: '#14b8a6',
    },
    {
      title: t('LABEL.PEER_EVALUATION'),
      to: '/lec/peer-evaluations',
      icon: 'fas fa-user-friends',
      bg: '#f0f9ff',
      color: '#0ea5e9',
    },
    {
      title: t('LABEL.NEWS'),
      to: '/lec/news-list',
      icon: 'fas fa-bullhorn',
      bg: '#fdf2f8',
      color: '#ec4899',
    },
    {
      title: t('LABEL.CHAT'),
      to: '/lec/chat-room',
      icon: 'fas fa-comment-dots',
      bg: '#f0fdf4',
      color: '#22c55e',
    },
  ]

  const moreMenus = [
    {
      title: t('LABEL.MY_UMEF'),
      to: '/lec/my-umef',
      icon: 'fas fa-university',
      color: '#7c3aed',
      internal: true,
    },
    {
      title: t('LABEL.UMEF_NEWS'),
      url: 'https://en.swiss-umef.ch/news-universite-geneve-suisse',
      icon: 'fas fa-newspaper',
      color: '#f97316',
    },
    {
      title: t('LABEL.MY_EVENTS'),
      url: 'https://en.swiss-umef.ch/evenements-universite-geneve',
      icon: 'fas fa-calendar-alt',
      color: '#eab308',
    },
  ]

  const renderCard = (icon: string, title: string, bg: string, color: string) => (
    <div
      className='menu-card d-flex flex-column align-items-center justify-content-center'
      style={{background: bg}}
    >
      <div className='icon-box mb-1'>
        <i className={icon} style={{color}}></i>
      </div>
      <span className='menu-text'>{title}</span>
    </div>
  )

  return (
    <div className='container-fluid d-flex flex-column align-items-center'>
      {/* MAIN ROW */}
      <div className='d-flex justify-content-center align-items-center gap-2 flex-nowrap'>
        {menus.map((menu, index) => (
          <div key={index}>
            <MenuItem to={menu.to} title={renderCard(menu.icon, menu.title, menu.bg, menu.color)} />
          </div>
        ))}

        {/* 🔥 MORE BUTTON (Bootstrap info color) */}
        <div onClick={() => setShowMore(!showMore)}>
          {renderCard(
            'fas fa-ellipsis-h',
            t('LABEL.MORE'),
            'linear-gradient(135deg, #0dcaf0, #0aa2c0)', // ✅ info style
            '#ffffff'
          )}
        </div>
      </div>

      {/* MORE PANEL BELOW */}
      {showMore && (
        <div className='more-container'>
          <div className='more-panel'>
            {moreMenus.map((menu, index) =>
              menu.internal ? (
                <MenuItem
                  key={index}
                  to={menu.to}
                  title={
                    <div className='more-card text-center'>
                      <i className={menu.icon} style={{color: menu.color}}></i>
                      <div className='more-text'>{menu.title}</div>
                    </div>
                  }
                />
              ) : (
                <a
                  key={index}
                  href={menu.url}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='more-card text-center'
                >
                  <i className={menu.icon} style={{color: menu.color}}></i>
                  <div className='more-text'>{menu.title}</div>
                </a>
              )
            )}
          </div>
        </div>
      )}

      <style>{`
      .menu-card {
  width: 95px;             
  height: 90px;
  border-radius: 16px;
  transition: 0.25s;
  cursor: pointer;
  padding: 6px 4px;
}

.menu-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.12);
}

.icon-box {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-box i {
  font-size: 17px;
}

.menu-text {
  font-size: 12.5px;
  font-weight: 600;
  text-align: center;
  line-height: 14px;

  display: -webkit-box;
  -webkit-line-clamp: 2;    
  -webkit-box-orient: vertical;

  overflow: hidden;
  word-break: break-word;
}

      /* MORE PANEL */
      .more-container {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 18px;
      }

      .more-panel {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 14px;
        padding: 18px;
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff, #eef2ff);
        box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        width: 100%;
        animation: fadeIn 0.25s ease;
      }

      .more-card {
        width: 170px;
        padding: 14px;
        border-radius: 16px;
        background: white;
        text-decoration: none;
        color: #333;
        transition: 0.25s;
      }

      .more-card:hover {
        transform: translateY(-4px) scale(1.05);
        background: #eef2ff;
      }

      .more-card i {
        font-size: 20px; /* 🔥 bigger */
        margin-bottom: 6px;
      }

      .more-text {
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
      }

      @keyframes fadeIn {
        from {opacity: 0; transform: translateY(10px);}
        to {opacity: 1; transform: translateY(0);}
      }
      `}</style>
    </div>
  )
}

export default LecMenu
